var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleCaseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50044 12.3332H0.666992L3.74288 3.6665H5.86511L8.92757 12.3332H7.0001L6.2815 10.1046H3.21904L2.50044 12.3332ZM4.79728 5.32365H4.71669L3.59513 8.82841H5.91884L4.79728 5.32365Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9633 12.3034C14.4425 12.3034 15.3337 11.2439 15.3337 9.48793V8.63079C15.3337 6.87484 14.4485 5.82127 12.987 5.82127C12.084 5.82127 11.3711 6.24388 11.1632 6.9046H11.086V3.6665H9.51761V12.2201H11.0622V11.2558H11.1394C11.3949 11.9046 12.084 12.3034 12.9633 12.3034ZM12.4405 11.0534C11.6385 11.0534 11.086 10.4225 11.086 9.49388V8.70817C11.086 7.70222 11.5969 7.07127 12.4227 7.07127C13.2544 7.07127 13.7296 7.70222 13.7296 8.79746V9.34508C13.7296 10.4284 13.2603 11.0534 12.4405 11.0534Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCaseButton);
export default __webpack_public_path__ + "static/media/titleCaseButton.c691879526a02224ec2ba29592216857.svg";
export { ForwardRef as ReactComponent };